/* eslint-disable no-underscore-dangle,prefer-arrow-callback,no-loop-func,
prefer-template */
// todo refactor this  into encapsulated components

const _each = require('lodash.foreach');
const dataLayerUtils = require('@dc/data-layer/src/utils.js');
const CollectInStoreItem =
  require('./components/native/collectInStoreItem/collectInStoreItem.jsx').default;
const uiLocale = require('./utils/UILocale.js');

const Callout = require('./components/callout');

const collectInStoreWrapper =
  document.querySelector('[data-component="collect-in-store-list-wrapper"]');
const fupid = collectInStoreWrapper ? collectInStoreWrapper.dataset.fupid : undefined;

const $storesList = $('ul.mcd-stores-list');
const $familyOfStoresBox = $('.family-of-stores');
const $checkDeliveryBox = $('.check-delivery-instead');
const $feedbackCenter = $('.mcd-feedback');
const $feedbackNoStock = $('.no-stock');
const $feedbackNoStockPostcode = $('.selected-postcode');

// for the situation as it is (still not completely POST COVID) let's keep this code and just hide the banner
const $infoBanner = $(`
    <div class="info-banner-wrapper">
        <div class="info-banner-message">
           ${uiLocale.getString('component.mcd.banner.text')}
        </div>
        <a class="lk simple-lk" href="https://www.currys.co.uk/gbuk/coronavirus-1222-commercial.html">
            More Info
        </a>
    </div>
`);

function initialiseWithEmptyFixtureData() {
  initialise([]);
}

function clearStoresList() {
  $storesList.empty();
  $infoBanner.remove();
  $feedbackCenter.removeClass('info-banner');
  $familyOfStoresBox.hide();
  $checkDeliveryBox.hide();
}

/** @param {StoreAvailability} availableStores */
/** @returns {void} */
function initialise(availableStores = [], showBanner = false) {
  let feedbackpostcodeText;
  let storeDetailsElements;
  clearStoresList();

  // Assuming that the array will be empty
  // if we need to show no stock feedback
  if (availableStores.length === 0) {
    $feedbackCenter.css({ display: 'none' });
    $feedbackNoStock.css({ display: 'block' });
    feedbackpostcodeText = $('.availability-area-input').text();
    if ($feedbackNoStockPostcode.text() === '') {
      $feedbackNoStockPostcode.text(feedbackpostcodeText);
    }
    $('.error-placeholder').style.display = 'none';
  } else {
    $storesList.show();

    if (showBanner) {
      $infoBanner.insertBefore('[data-component="collect-in-store-list-wrapper"]');
      $feedbackCenter.addClass('info-banner');
    }

    displayStores(availableStores);

    // if user tried to copy address from collect in store show callout
    // todo load text from json-ld settings once in translation
    // todo, think about moving this to tourguide and use custom event from here to set it up
    storeDetailsElements =
      document.querySelectorAll('.mcd-stores-list .store-details .store-address');
    if (storeDetailsElements.length) {
      _each(storeDetailsElements, function callback(element) {
        element.addEventListener('copy', function storeAddressOnCopy(event) {
          const callout = new Callout(
            window.App.locale.getString('tourguide.copy_store.header'),
            window.App.locale.getString('tourguide.copy_store.label'),
            'Got it'
          );
          event.stopPropagation();
          callout.show(event.currentTarget, Callout.ALIGNMENT_BOTTOM);
        });
      });
    }
  }
}

/** @param {Array<StoreAvailability>} availableStores */
/** @returns {void} */
function displayStores(availableStores) {

  const availableStoresLength = availableStores.length;
  let i = 0;

  if (availableStores[i].isOutOfStock()) {
    $storesList.append('<li class="store-stock-location"></li>');
    $storesList.find('li:last').html('Your nearest store');

    // iterator is here beacause 2 store lists exist. One for touch and one for desktop
    $storesList.each(function callback(storeElNumber, storeEl) {
      storeEl.appendChild(getStoreItem(availableStores[i], i, availableStoresLength, fupid));
    });
    if (availableStores.length > 1) {
      $storesList.append('<li class="store-stock-location"></li>');
      $storesList.find('li:last').html('Nearest stores with stock');
    }
    i++;
  }

  for (; i < availableStoresLength; i++) {
    // iterator is here beacause 2 store lists exist. One for touch and one for desktop
    $storesList.each(function callback(storeElNumber, storeEl) {
      const storeItem = getStoreItem(availableStores[i], i, availableStoresLength, fupid);

      if (storeItem) {
        storeEl.appendChild(storeItem);
      }
    });
  }

  $familyOfStoresBox.show();
  $checkDeliveryBox.show();

  Array.prototype.forEach.call(
    document.querySelectorAll('ul.mcd-stores-list > li.store'),
    addExpandStoreListener
  );
}

/** @param {StoreAvailability} availableStores
 *  @param {integer} index
 *  @param {integer} availableStoresLength
 *  @returns {HTMLElement} */
function getStoreItem(storeAvailability, index, availableStoresLength) {
  const collectInStoreItem =
    new CollectInStoreItem(storeAvailability, index, availableStoresLength, fupid);
  return collectInStoreItem;
}

function addExpandStoreListener(store) {
  const expandElement = store.querySelector('.store-state');

  expandElement.onclick = function onClick() {

    const collapsed = store.getAttribute('data-collapsed') === 'true';

    const storeExpandedEvent = {
      type: 'STORE_LOCATOR_STORE_EXPANDED',
      payload: {}
    };

    if (collapsed) {

      if (store.className.indexOf('first-store') !== -1) {
        storeExpandedEvent.payload.storeClicked = '1';
      } else if (store.className.indexOf('last-store') !== -1) {
        storeExpandedEvent.payload.storeClicked = '3';
      } else {
        storeExpandedEvent.payload.storeClicked = '2';
      }

      window.appState.dispatch(storeExpandedEvent);
      dataLayerUtils.satelliteTrack('View Store Opening Hours');
    }

    store.setAttribute('data-collapsed', !collapsed);
  };
}

module.exports = {
  initialiseWithEmptyFixtureData: initialiseWithEmptyFixtureData,
  initialise: initialise,
  clearStoresList: clearStoresList
};
